import { ClientPluginInstance3k1rpw72h98wh as ClientPluginInstance } from './ClientPluginInstance.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createKTypeParameter16gw97ll17xmd as createKTypeParameter,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createClientPlugin(name, createConfiguration, body) {
  return new (ClientPluginImpl())(name, createConfiguration, body);
}
function createClientPlugin_0(name, body) {
  return createClientPlugin(name, createClientPlugin$lambda, body);
}
var ClientPluginImplClass;
function ClientPluginImpl() {
  if (ClientPluginImplClass === VOID) {
    class $ {
      constructor(name, createConfiguration, body) {
        this.r5s_1 = createConfiguration;
        this.s5s_1 = body;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(ClientPluginInstance());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(ClientPluginInstance()), arrayOf([createInvariantKTypeProjection(createKType(createKTypeParameter('PluginConfigT', arrayOf([createKType(PrimitiveClasses_getInstance().rf(), arrayOf([]), false)]), 'invariant', false, 'io.ktor.client.plugins.api.ClientPluginImpl'), arrayOf([]), false))]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.t5s_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      m3() {
        return this.t5s_1;
      }
      u5s(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.r5s_1();
        block(this_0);
        var config = this_0;
        return new (ClientPluginInstance())(this.t5s_1, config, this.s5s_1);
      }
      d5i(block) {
        return this.u5s(block);
      }
      v5s(plugin, scope) {
        plugin.t5g(scope);
      }
      e5i(plugin, scope) {
        return this.v5s(plugin instanceof ClientPluginInstance() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForClass($, 'ClientPluginImpl');
    ClientPluginImplClass = $;
  }
  return ClientPluginImplClass;
}
function createClientPlugin$lambda() {
  return Unit_instance;
}
//region block: exports
export {
  createClientPlugin_0 as createClientPlugin16sdkdabbewya,
  createClientPlugin as createClientPluginjwpvufjows5r,
};
//endregion

//# sourceMappingURL=CreatePluginUtils.mjs.map
